"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourceFetcherToken = exports.OpenRTBContext = void 0;
var OpenRTBContext;
(function (OpenRTBContext) {
    OpenRTBContext[OpenRTBContext["video"] = 1] = "video";
    OpenRTBContext[OpenRTBContext["game"] = 2] = "game";
    OpenRTBContext[OpenRTBContext["music"] = 3] = "music";
    OpenRTBContext[OpenRTBContext["application"] = 4] = "application";
    OpenRTBContext[OpenRTBContext["text"] = 5] = "text";
    OpenRTBContext[OpenRTBContext["other"] = 6] = "other";
    OpenRTBContext[OpenRTBContext["unknown"] = 7] = "unknown";
})(OpenRTBContext = exports.OpenRTBContext || (exports.OpenRTBContext = {}));
var SourceFetcherToken;
(function (SourceFetcherToken) {
    SourceFetcherToken["id"] = "idtoken";
    SourceFetcherToken["mira"] = "miratoken";
    SourceFetcherToken["pin"] = "pin";
    SourceFetcherToken["deviceId"] = "deviceId";
    SourceFetcherToken["abTestAllowed"] = "ab_test_allowed";
})(SourceFetcherToken = exports.SourceFetcherToken || (exports.SourceFetcherToken = {}));
//# sourceMappingURL=source-fetcher.js.map